import { useState, useMemo } from 'react';
import { LeaderboardEntry } from '../types';

export type TimeFilter = 'all' | 'month' | 'week';

export const useLeaderboard = () => {
    const [timeFilter, setTimeFilter] = useState<TimeFilter>('all');

    const leaderboard: LeaderboardEntry[] = useMemo(() => [
        {
            id: 1,
            rank: 1,
            name: 'Nguyễn Văn A',
            points: 1250,
            coursesCompleted: 15,
            badge: '🥇'
        },
        {
            id: 2,
            rank: 2,
            name: 'Trần Thị B',
            points: 1180,
            coursesCompleted: 14,
            badge: '🥈'
        },
        {
            id: 3,
            rank: 3,
            name: 'Lê Văn C',
            points: 1100,
            coursesCompleted: 13,
            badge: '🥉'
        },
        {
            id: 4,
            rank: 4,
            name: 'Phạm Thị D',
            points: 980,
            coursesCompleted: 12
        },
        {
            id: 5,
            rank: 5,
            name: 'Hoàng Văn E',
            points: 920,
            coursesCompleted: 11
        },
        {
            id: 6,
            rank: 6,
            name: 'Vũ Thị F',
            points: 850,
            coursesCompleted: 10
        },
        {
            id: 7,
            rank: 7,
            name: 'Đỗ Văn G',
            points: 780,
            coursesCompleted: 9
        },
        {
            id: 8,
            rank: 8,
            name: 'Bùi Thị H',
            points: 720,
            coursesCompleted: 8
        }
    ], []);

    return {
        leaderboard,
        timeFilter,
        setTimeFilter
    };
};
